

























import Vue from 'vue';
import TripSampleCard from './trip-sample-card.vue';
import TripSampleCardSkeleton from './trip-sample-card-skeleton.vue';
import {Trip} from '@/store/api/download-destination-trips';

export default Vue.extend({
  components: {
    TripSampleCard,
    TripSampleCardSkeleton,
  },
  name: 'SampleCardsRow',
  props: {
    samples: {
      type: Array as () => Trip[],
      default: () => [],
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
});
